import classNames from 'classnames'
import { memo, useCallback, useState } from 'react'
import { useTranslate } from '../../../hooks/language/use-translate'
import { Messages } from './messages'

export const ChatLive = memo(() => {
  const [filter, setFilter] = useState<'all' | 'gifts' | 'chat'>('all')

  const handleChangeFilter = useCallback(
    (value: string) => {
      setFilter(value as 'all' | 'gifts' | 'chat')
    },
    [setFilter],
  )

  const { translate } = useTranslate()

  return (
    <div className="w-screen h-screen flex flex-col text-white overflow-hidden">
      <div className="flex flex-rol gap-4 transition-all mb-1 w-72 bg-transparent">
        <span
          className={classNames({
            'font-bold': filter === 'all',
            'opacity-50': filter !== 'all',
          })}
          onClick={() => handleChangeFilter('all')}
        >
          {translate('chat-live-all')}
        </span>

        <span
          className={classNames({
            'font-bold': filter === 'chat',
            'opacity-50': filter !== 'chat',
          })}
          onClick={() => handleChangeFilter('chat')}
        >
          CHAT
        </span>

        <span
          className={classNames({
            'font-bold': filter === 'gifts',
            'opacity-50': filter !== 'gifts',
          })}
          onClick={() => handleChangeFilter('gifts')}
        >
          {translate('chat-live-gifts')}
        </span>
      </div>

      <Messages filter={filter} />
    </div>
  )
})
